import { Component, OnInit } from '@angular/core';
import { take, finalize } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

import { UrlParamsService } from '~common/app/shared/services/url-params.service';

import { AuthService } from '../../../auth/services/auth.service';
import { AppService } from '../../../shared/services/app.service';
import { OfferService } from '../../services/offer.service';
import { Offer } from '../../../shared/models/offer';
import { settings } from '../../../app.settings';

import tracking from '~common/app/shared/utils/tracking';

@Component({
  selector: 'app-offer-list-page',
  templateUrl: './offer-list-page.component.html',
  styleUrls: ['./offer-list-page.component.sass']
})
export class OfferListPageComponent implements OnInit {
  loading: boolean;
  offers: Offer[] = [];
  canCreateOffers = false;
  perPage = settings.pagination.perPage;
  total = 0;
  params: any = {};
  totals = {
    all: 0,
    published: 0,
    ended: 0,
    pending: 0,
    active: 0
  };

  tab: string;
  page: number;
  ordering: string;
  filters: any = {
    term: null,
    start_date: null,
    end_date: null
  }

  constructor(
    public authService: AuthService,
    private appService: AppService,
    private offerService: OfferService,
    private urlParamsService: UrlParamsService,
    private route: ActivatedRoute,
  ) {
    this.appService.setTitle('offers.list.heading');
    this.params = this.route.snapshot.data;
  }

  ngOnInit() {
    this.loadCounters();
    this.initQueryParamsWatcher();
    tracking.sendEvent('page.display', { page: 'Offers' })
  }

  initQueryParamsWatcher() {
    this.route.queryParams.subscribe(params => {
      this.page = params.page || 1;
      this.tab = params.tab || 'ACTIVE';
      this.ordering = params.ordering || '-created_at';
      this.filters = {
        term: params.term,
        start_date: params.start_date,
        end_date: params.end_date,
      }

      this.loadEntities();
    })
  }

  updateQueryParams() {
    this.urlParamsService.set({
      page: this.page,
      tab: this.tab,
      ordering: this.ordering,
      ...this.filters,
    });
  }

  onPageChange(page: number) {
    this.page = page;
    this.updateQueryParams();
  }

  onFiltersChange(filters: any) {
    this.filters = filters;
    this.page = 1;
    this.updateQueryParams();
  }

  onOrderingChange(ordering: string) {
    this.ordering = ordering;
    this.updateQueryParams();
  }

  onChangeTab(tab: string) {
    this.tab = tab;
    this.page = 1;
    this.filters = {}
    this.ordering = null
    this.updateQueryParams();
  }

  private loadCounters() {
    this.offerService.fetchCounters()
      .pipe(
        take(1)
      )
      .subscribe((response: any) => {
        let all = 0;

        Object.keys(response).forEach(key => all += response[key]);
        this.totals.all = all;
        this.totals.active = response.ACTIVE + response.PUBLISHED;
        this.totals.pending = response.WAITING_FOR_PUBLICATION + response.DRAFT;
        this.totals.ended = response.DEACTIVATED + response.ENDED + response.COMPLETED;
      });
  }

  private loadEntities() {
    let method = '', status = [];

    this.loading = true;

    if (this.params.history) {
      method = 'fetchHistory';
    } else {
      method = 'fetch';
    }

    switch (this.tab) {
      case 'ACTIVE':
        status = ['ACTIVE', 'PUBLISHED'];
        break;

      case 'PENDING':
        status = ['WAITING_FOR_PUBLICATION', 'DRAFT'];
        break;

      case 'ENDED':
        status = ['ENDED', 'DEACTIVATED', 'COMPLETED'];
        break;

      default:
        status = null;
    }

    this.offerService[method]({
      page: this.page,
      per_page: this.perPage,
      filters: this.filters,
      sort: this.ordering,
      status: status,
    })
      .pipe(
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((response: any) => {
        this.offers = response.items;
        this.total = response.meta.total;
      });
  }
}
